import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { AppConfigProvider, } from '#src/app/app-config.js';
import { createQueryClient } from '#src/app/query-client.js';
import { createRouter } from '#src/app/router.js';
import { AuthProvider } from '#src/auth/AuthProvider.js';
import { SessionGate } from '#src/auth/session.js';
import { TeamsHostProvider } from '#src/teams/TeamsHostProvider.js';
import { ThemeProvider } from '#src/theme/ThemeProvider.js';
/**
 * Ordem dos providers, de fora para dentro: descobrir se está no Teams, aplicar
 * o tema (que depende disso), obter o token (idem), carregar a sessão e só
 * então as rotas, que já sabem as permissões.
 */
export function TeamsKitApp({ config }) {
    const [queryClient] = useState(createQueryClient);
    const [router] = useState(() => createRouter(config.modules));
    return (_jsx(AppConfigProvider, { config: config, children: _jsx(TeamsHostProvider, { children: _jsx(ThemeProvider, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(AuthProvider, { children: _jsx(SessionGate, { children: _jsx(RouterProvider, { router: router }) }) }) }) }) }) }));
}
//# sourceMappingURL=TeamsKitApp.js.map